import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CopyLinkService {
  private document = inject(DOCUMENT);
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getTokenForLinkSharingService(file: any, showLoader = true): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/filesystem/${file.id}/link`, {
      showLoader,
      showMessage: true
    });
  }

  generatedLink(file: any): string {
    return `${this.document.location.origin}/share?token=${file?.link?.token}`;
  }

  toggleLinkRestrictionService(file: any, showLoader = true): Observable<any> {
    return this.#http.putData<any>(`${this.baseUrl}/filesystem/${file?.id}/link/toggle`, '', {
      showLoader,
      showMessage: true,
      message: 'Link restriction updated successfully'
    });
  }
}
